

import {
  HasilDarahRecord,
  HasilDarahKantong
} from "@/types/hasil_pemeriksaan_darah";

export interface SumberInkompatibel {
  value: string;
  text: string;
  hasil: HasilDarahRecord;
  kantong: HasilDarahKantong | null;
}

export interface CrossmatchPrefill {
  mayor: string;
  minor: string;
  auto_control: string;
  dct: string;
  ict: string;
}

export function kantongInkompatibel(
  hasil: HasilDarahRecord
): HasilDarahKantong[] {
  const semua = hasil.kantong || [];
  const buruk = semua.filter(k => k.hasil_uji_silang === "inkompatibel");

  return buruk.length ? buruk : semua;
}

function labelSumber(
  hasil: HasilDarahRecord,
  kantong: HasilDarahKantong | null,
  waktu: (v: string | null) => string
): string {
  const bagian: string[] = [hasil.nomor || "(tanpa nomor)"];
  const tgl = waktu(hasil.daftar_at);

  if (tgl) bagian.push(tgl);
  if (kantong) bagian.push(`Kantong ${kantong.kode_kantong || "-"}`);

  return bagian.join(" — ");
}

export function opsiSumberInkompatibel(
  items: HasilDarahRecord[],
  waktu: (v: string | null) => string
): SumberInkompatibel[] {
  const keluar: SumberInkompatibel[] = [];

  (items || [])
    .filter(h => h && h.kesimpulan_donor === "inkompatibel")
    .forEach(h => {
      const kantong = kantongInkompatibel(h);

      if (!kantong.length) {
        keluar.push({
          value: `${h.id}:0`,
          text: labelSumber(h, null, waktu),
          hasil: h,
          kantong: null
        });

        return;
      }

      kantong.forEach((k, i) => {
        const kunci =
          k.id !== null && k.id !== undefined
            ? k.id
            : k.urutan !== null && k.urutan !== undefined
            ? k.urutan
            : i;

        keluar.push({
          value: `${h.id}:${kunci}`,
          text: labelSumber(h, k, waktu),
          hasil: h,
          kantong: k
        });
      });
    });

  return keluar;
}

export function crossmatchDariSumber(
  sumber: SumberInkompatibel,
  labelReaksi: (v: string | null) => string
): CrossmatchPrefill {
  const k = sumber.kantong;

  return {
    mayor: k ? labelReaksi(k.mayor) : "",
    minor: k ? labelReaksi(k.minor) : "",
    auto_control: k ? labelReaksi(k.auto_kontrol) : "",
    dct: labelReaksi(sumber.hasil.dct),
    ict: labelReaksi(sumber.hasil.ict)
  };
}

export function jejakSumber(sumber: SumberInkompatibel) {
  return {
    hasil_id: sumber.hasil.id,
    nomor: sumber.hasil.nomor,
    kode_kantong: sumber.kantong ? sumber.kantong.kode_kantong : null
  };
}
